import { reactify } from '@zeiss/zui-react';
export const ZuiIconLayoutGrid12Units = reactify('zui-icon-layout-grid-12-units');
